import React, { useState } from 'react'
import './HomePage.css'
import {
  Heart,
  Mail,
  Phone,
  MapPin,
  Eye,
  EyeOff,
  LogIn,
  User,
  Lock,
  BookOpen,
  Shield,
  Users,
} from 'lucide-react'
import LOGO from '../Assets/LOGO.png'
import { useNavigate } from 'react-router-dom'
import { AdminLoginAPI } from '../APIComponents/AdminApi'
import { toast } from 'react-toastify'
import axios from 'axios'

export default function HomePage() {
  const [showPassword, setShowPassword] = useState(false)
  const year = new Date().getFullYear()

  const [loginId, setLoginId] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState('')
  const navigate = useNavigate()

  // const handleLogin = async (e) => {
  //   e.preventDefault()

  //   if (!loginId || !password) {
  //     toast.error('Please enter both loginId and password')
  //     return
  //   }

  //   setLoading(true)

  //   try {
  //     const res = await axios.post(AdminLoginAPI, {
  //       login_id:loginId,
  //       password:password,
  //     })

  //     setLoading(false)

  //     const data = res.data
  //     if (data == "BLOCKED_USER") {
  //       toast.error('User blocked by admin!')
  //     }
  //     if (data == "INVALID_CREDENTIALS") {
  //       toast.warn('Invalid Credentials!')
  //     }

  //     // USER LOGIN
  //     if (data.message === 'USER_LOGIN_SUCCESS') {
  //       toast.success('Login Successfully!')

  //       // Store complete response
  //       sessionStorage.setItem('userData', JSON.stringify(data))
  //       sessionStorage.setItem('adminAuth', data.token)

  //       navigate('/dashboard')
  //       return
  //     }

  //     // ADMIN LOGIN
  //     if (data.message === 'ADMIN_LOGIN_SUCCESS') {
  //       toast.success('Admin Login Successfully!')

  //       sessionStorage.setItem('userData', JSON.stringify(data))
  //        sessionStorage.setItem('adminAuth', data.token)

  //       navigate('/dashboard')
  //       return
  //     }

  //   } catch (error) {
  //     setLoading(false)
  //     toast.error('Something went wrong. Please try again.')
  //     console.error('Error:', error)
  //   }
  // }

  const handleLogin = async (e) => {
    e.preventDefault()

    if (!loginId || !password) {
      toast.error('Please enter both loginId and password')
      return
    }

    setLoading(true)

    try {
      const res = await axios.post(AdminLoginAPI, {
        login_id: loginId,
        password: password,
      })

      setLoading(false)

      const data = res.data

      // BLOCKED USER
      if (data === 'BLOCKED_USER') {
        toast.error('User blocked by admin!')
        return
      }

      // INVALID
      if (data === 'INVALID_CREDENTIALS') {
        toast.warn('Invalid Credentials!')
        return
      }

      // ================= USER LOGIN =================
      if (data.message === 'USER_LOGIN_SUCCESS') {
        toast.success('Login Successfully!')

        sessionStorage.setItem('adminAuth', data.token)
        sessionStorage.setItem('loginType', data.login_type) // USER
        sessionStorage.setItem('userId', data.user_id)
        sessionStorage.setItem('loginId', data.login_id)
        sessionStorage.setItem('roleId', data.role.role_id)
        sessionStorage.setItem('roleName', data.role.role_name)

        // Store menus + permissions
        sessionStorage.setItem('menus', JSON.stringify(data.menus))

        // Optional: store full object
        sessionStorage.setItem('userData', JSON.stringify(data))

        navigate('/dashboard')
        return
      }

      // ================= ADMIN LOGIN =================
      if (data.message === 'ADMIN_LOGIN_SUCCESS') {
        toast.success('Admin Login Successfully!')

        sessionStorage.setItem('adminAuth', data.token)
        sessionStorage.setItem('loginType', data.login_type) // ADMIN
        sessionStorage.setItem('adminId', data.admin_id)
        sessionStorage.setItem('loginId', data.login_id)

        // Admin does not have menus in response
        sessionStorage.removeItem('menus')

        sessionStorage.setItem('userData', JSON.stringify(data))

        navigate('/dashboard')
        return
      }
    } catch (error) {
      setLoading(false)
      toast.error('Something went wrong. Please try again.')
      console.error('Error:', error)
    }
  }

  return (
    <div className="app">
      {/* ================= HEADER ================= */}
      <header className="header">
        <div className="header-container">
          <div className="logo-area">
            <div className="logo-box">
              <img
                src={LOGO}
                alt="logo"
                style={{ width: '100px', height: '90px' }}
              />
            </div>
            <div>
              <h1>St. Crispins Home</h1>
              <p style={{ color: '#f04e23' }}>PUNE, MAHARASHTRA</p>
            </div>
          </div>
        </div>
      </header>

      {/* ================= HERO ================= */}
      <main className="hero">
        <div className="hero-overlay"></div>

        <div className="hero-content">
          {/* LEFT */}
          <div className="hero-text">
            {/* <span className="badge">NGO Portal for Girls</span> */}

            <h2>
              Empowering Every <span>Girl Child</span> to Dream Big
            </h2>

            <p>
              We provide education, care, and a loving environment for orphan
              and underprivileged girls.
            </p>

            <div className="stats">
              <div>
                <h3>500+</h3>
                <p>Girls Supported</p>
              </div>
              <div>
                <h3>25+</h3>
                <p>Years of Service</p>
              </div>
              <div>
                <h3>100%</h3>
                <p>Education Focus</p>
              </div>
            </div>
          </div>

          {/* RIGHT – LOGIN */}
          <div className="login-box">
            <div className="login-icon">
              <User />
            </div>
            <h3>Welcome Back</h3>

            {/* <form>
              <label>Email / Username</label>
              <input type="text" placeholder="Enter email or username" />

              <label>Password</label>
              <div className="password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff /> : <Eye />}
                </button>
              </div>

              <button className="login-btn">
                <LogIn /> Sign In
              </button>
            </form> */}

            <form onSubmit={handleLogin}>
              <label className="labelText">Email / Login Id</label>
              <input
                type="text"
                placeholder="Enter email or loginId"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                required
                style={{ color: 'black' }}
              />

              <label className="labelText">Password</label>
              <div className="password-field">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ color: 'black' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff /> : <Eye />}
                </button>
              </div>

              {/* <button type="submit" className="login-btn" loading={loading}>
                <LogIn /> Sign In
              </button> */}

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? (
                  'Signing In...'
                ) : (
                  <>
                    {' '}
                    <LogIn /> Sign In{' '}
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* ================= MARQUEE ================= */}
      <div className="marquee">
        <div className="marquee-track">
          {[Heart, BookOpen, Shield, Users].map((Icon, i) => (
            <div key={i} className="marquee-item">
              <Icon />
              <span>Empowering Girls Through Education & Care</span>
            </div>
          ))}
          {[Heart, BookOpen, Shield, Users].map((Icon, i) => (
            <div key={i + 4} className="marquee-item">
              <Icon />
              <span>Empowering Girls Through Education & Care</span>
            </div>
          ))}
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <footer className="footer">
        <div className="footer-grid">
          <div>
            <h4>
              <img src={LOGO} alt="logo" style={{ width: '60px' }} /> St.
              Crispins Home
            </h4>
            <p>
              Dedicated to providing education, care, and a loving home for
              orphan and underprivileged girls.
            </p>
          </div>

          <div>
            <h4 style={{ color: '#f04e23' }}>Quick Links</h4>
            <a href="#">Privacy Policy</a>
            <a href="#">Terms & Conditions</a>
            <a href="#">Get Involved</a>
          </div>

          <div>
            <h4 style={{ color: '#f04e23' }}>Contact Us</h4>
            <p>
              <Mail
                style={{
                  color: '#f04e23',
                  fontSize: '16px',
                  padding: '5px',
                  marginRight: '5px',
                  borderRadius: '50px',
                  backgroundColor: '#31405f',
                }}
              />{' '}
              info@stcrispinshome.org
            </p>
            <p>
              <Phone
                style={{
                  color: '#f04e23',
                  fontSize: '16px',
                  padding: '5px',
                  marginRight: '5px',
                  borderRadius: '50px',
                  backgroundColor: '#31405f',
                }}
              />{' '}
              +91 98765 43210
            </p>
            <p>
              <MapPin
                style={{
                  color: '#f04e23',
                  fontSize: '16px',
                  padding: '5px',
                  marginRight: '5px',
                  borderRadius: '50px',
                  backgroundColor: '#31405f',
                }}
              />{' '}
              Pune, Maharashtra
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <span style={{ fontSize: '16px', color: '#9b9999' }}>
            © {year} St. Crispins Home. All Rights Reserved.
          </span>{' '}
          <br />
          Managed by TechnoAarv Solution
        </div>
      </footer>
    </div>
  )
}
